import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@homeaway/react-buttons';

export class InvoiceSummaries extends React.Component {
    static propTypes = {
        invoiceDownloadSummaries: PropTypes.arrayOf(
            PropTypes.shape({
                downloadLinkText: PropTypes.string,
                downloadLinkUrl: PropTypes.string,
                text: PropTypes.string,
                title: PropTypes.string,
            })
        ),
    };

    render() {
        const {invoiceDownloadSummaries} = this.props;
        let summaries = [];

        if (!invoiceDownloadSummaries || invoiceDownloadSummaries.length <= 0) {
            return null;
        }

        invoiceDownloadSummaries.forEach((invoice, index) => {
            summaries.push(
                <div
                    className="section-with-border text-center hidden-print"
                    key={`invoice-${index}`}
                >
                    <h3>{invoice.title}</h3>
                    <p>{invoice.text}</p>
                    <div className="row">
                        <div className="col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1 col-xs-12">
                            <Button
                                block
                                className={'btn--nowrap'}
                                href={invoice.downloadLinkUrl}
                                label={invoice.downloadLinkText}
                                target={'_blank'}
                            />
                        </div>
                    </div>
                </div>
            );

            if (index !== invoiceDownloadSummaries.length - 1) {
                summaries.push(
                    <div
                        className="th-section-divider with-border-xs"
                        key={`divider-${index}`}
                    />
                );
            }
        });

        return <div className="InvoiceSummaries">{summaries}</div>;
    }
}
